import { objectSchema, ObjectSchema } from "utils/object-methods";
import { WhatsAppSessionProps } from ".";
import { fieldValidation } from "utils/field-validation";
import { isUserGerente } from "utils/is-gerente";
import { User } from "contexts/types/application-context-types";

export function validateSessionWhatsApp(
  session: Partial<WhatsAppSessionProps>,
  tipoDeAtribuicao: "vendedores" | "equipes",
  user: User
) {
  const isGerente = isUserGerente(user);
  const schema: ObjectSchema<WhatsAppSessionProps> = {
    associarNovosAtendimentos: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    customerId: (value) => {
      if (isGerente) {
        let valid = fieldValidation({ value }).required().isValid;
        return { valid, message: "Preencha o campo corretamente" };
      }
      return { valid: true, format: null };
    },
    nome: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
    novosAtendimentosEquipeId: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      if (session.associarNovosAtendimentos && tipoDeAtribuicao === "equipes") {
        return { valid: isValid, message: "Preencha o campo corretamente" };
      }
      return { valid: true, format: null };
    },
    novosAtendimentosUsersIds: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      if (
        session.associarNovosAtendimentos &&
        tipoDeAtribuicao === "vendedores"
      ) {
        return { valid: isValid, message: "Preencha o campo corretamente" };
      }
      return { valid: true, format: null };
    },
    type: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "Preencha o campo corretamente" };
    },
  };
  return objectSchema(schema, session);
}
